export const walletFlowType = {
  NAS_WALLET: 'nas_wallet',
  METAMASK_WALLET: 'metamask_wallet',
  WALLET_SELECT: 'wallet_select',
  CLAIM_NFT: 'claim_nft',
  ERROR: 'error',
  ADDRESS_CHANGE: 'address_change',
};

export const walletTypes = {
  NAS_WALLET: 'naswallet',
  METAMASK: 'metamask',
};

export const getSigningMessage = ({ address }) => {
  return `Welcome to Nas Academy\n\nWallet Address: ${address}`;
};
